import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import {HttpClientModule, HTTP_INTERCEPTORS, HttpClient} from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { CommonModule } from '@angular/common';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';

import { routes } from './app.routes';
import { environment } from '../environments/environment';


// export function createTranslateLoader(http: HttpClient): any {
//     return new TranslateHttpLoader(http, "assets/i18n/", ".json");
// }
/**
 * This module provides a traditional NgModule approach for the application.
 * It can be used alongside standalone components or as a migration path
 * from standalone components to NgModule-based architecture.
 */
@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    RouterModule.forRoot(routes, {
      paramsInheritanceStrategy: 'always',
      onSameUrlNavigation: 'reload'
    }),
    HttpClientModule,
    // ServiceWorkerModule.register('ngsw-worker.js', {
    //   enabled: !environment.production,
    //   registrationStrategy: 'registerWhenStable:30000'
    // }),
      // TranslateModule.forRoot({
      //     defaultLanguage: "en",
      //     loader: {
      //         provide: TranslateLoader,
      //         useFactory: createTranslateLoader,
      //         deps: [HttpClient],
      //     },
      // }),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  exports: [
    BrowserModule,
    RouterModule,
    HttpClientModule
  ]
})
export class AppModule { }
